import Immutable from 'seamless-immutable'
import {
  SET_CREATED_CHANNEL_URL,
  IS_FETCHING_CREATE_CHANNEL,
  SET_ERROR,
  CLEAR_ERROR,
  SET_REMOVED_CHANNEL_URL,
  SET_UNREAD_MESSAGES_COUNT,
  SET_SENDBIRD_USER,
  SET_IS_BROWSING_FILES,
  SET_SENDBIRD_USER_DISCONNECT,
  SET_WARNING_MODAL_TYPE,
  SET_CLIENT_SETTINGS,
  ADD_RECIPIENT_MEMBER_BANKID_VERIFIED_CHANNEL_URLS,
  CLEAR_RECIPIENT_MEMBER_BANKID_VERIFIED_CHANNEL_URLS,
  SET_USER_SUSPENDED_TYPE,
} from './actions'

const initialState = Immutable.from({
  error: {
    type: null,
    subject: null,
    description: null,
    data: null,
    displayError: null,
    targets: [], // optional
  },
  isFetching: false,
  isBrowsingFiles: false,
  channelUrl: '',
  removedChannelUrl: null,
  unreadMessagesCount: 0,
  sendbirdUser: {
    connected: null,
  },
  checkedRecipientBankIdVerifiedChannels: [],
  warningModal: {
    type: '',
  },
  clientSettings: {},
  userSuspendedType: '',
})

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CLEAR_ERROR:
      // prevent error from clearing, unless payload contains 'clear_static',
      // shouldn't be the case, but works as a fallback
      if (state.error.type === 'general_static') {
        if (payload === 'clear_static') {
          return state.set('error', initialState.error)
        }
        return state
      }
      return state.set('error', initialState.error)
    case SET_ERROR:
      // prevent state mutation if current state is 'general_static',
      // since its interpreted as "larger" then any other error,
      // shouldn't be the case, but works as a fallback
      if (state.error.type === 'general_static') {
        return state
      }
      switch (payload.type) {
        case 'offline':
          return state.set('error', {
            subject: 'Ingen internetanslutning.',
            description: 'Försök igen senare.',
            type: payload.type,
            data: payload.data,
          })
        case 'multiple_errors_files/images':
          return state.set('error', {
            type: payload.type,
            data: payload.data,
          })
        case 'general':
          const sendbirdErrorCode = payload.data?.code
          const displayError = sendbirdErrorCode && `(Felkod: W-SBD-${sendbirdErrorCode})`
          return state.set('error', {
            subject: 'Tillfälligt fel.',
            description: 'Försök igen senare.',
            type: payload.type,
            data: payload.data,
            displayError,
          })
        case 'general_static':
          return state.set('error', {
            subject: 'Tillfälligt fel.',
            description: 'Testa ladda om sidan eller försök igen senare.',
            type: payload.type,
            data: payload.data,
          })
        case 'channel_not_found':
          return state.set('error', {
            type: payload.type,
          })
        default:
          // eslint-disable-next-line no-console
          console.warn(`Warning: ${payload.type} is not supported.`)
          return state
      }
    case IS_FETCHING_CREATE_CHANNEL:
      return state.set('isFetching', payload)
    case SET_IS_BROWSING_FILES:
      return state.set('isBrowsingFiles', payload)
    case SET_CREATED_CHANNEL_URL:
      return state.set('channelUrl', payload).set('isFetching', false)
    case SET_REMOVED_CHANNEL_URL:
      return state.set('removedChannelUrl', payload)
    case SET_UNREAD_MESSAGES_COUNT:
      return state.set('unreadMessagesCount', payload ?? 0)
    case SET_SENDBIRD_USER:
      return state.set('sendbirdUser', payload).setIn(['sendbirdUser', 'connected'], true)
    case SET_SENDBIRD_USER_DISCONNECT:
      return state.setIn(['sendbirdUser', 'connected'], false)
    case SET_WARNING_MODAL_TYPE:
      return state.setIn(['warningModal', 'type'], payload)
    case SET_CLIENT_SETTINGS:
      return state.set('clientSettings', payload)
    case ADD_RECIPIENT_MEMBER_BANKID_VERIFIED_CHANNEL_URLS:
      return state.set(
        'checkedRecipientBankIdVerifiedChannels',
        state.checkedRecipientBankIdVerifiedChannels.concat(payload),
      )
    case CLEAR_RECIPIENT_MEMBER_BANKID_VERIFIED_CHANNEL_URLS:
      return state.set(
        'checkedRecipientBankIdVerifiedChannels',
        initialState.checkedRecipientBankIdVerifiedChannels,
      )
    case SET_USER_SUSPENDED_TYPE:
      return state.set('userSuspendedType', payload)
    default:
      return state
  }
}
